


import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class FieldBoolean extends Vue {
    @Prop() public Value!: boolean;
}
